module.exports = __webpack_public_path__ + "static/media/logo-모자이크@3x.567fa755.png";